/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WizardModule} from '../../shared/wizard/wizard.module';
import {ReactiveFormsModule} from '@angular/forms';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {ClaimCreateNewComponent} from './claim-create-new.component';
import {StepClaimInformationComponent} from './step-claim-information/step-claim-information.component';
import {NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {WarningsModule} from '../../shared/warnings/warnings.module';
import {StepPositionDetailComponent} from './step-position-detail/step-position-detail.component';
import {MaterialPositionTableModule} from '../shared/material-position-table/material-position-table.module';
import {InputModule} from '../../shared/input/input.module';
import {ClaimInformationDisplayModule} from '../shared/claim-information-display/claim-information-display.module';
import {StepConfirmSendComponent} from './step-confirm-send/step-confirm-send.component';
import {ClaimInformationFormModule} from '../shared/claim-information-form/claim-information-form.module';
import {AttachmentsListDisplayModule} from '../shared/attachments-list-display/attachments-list-display.module';

@NgModule({
    imports: [
        CommonModule,
        WizardModule,
        LoadingSpinnerModule,
        ReactiveFormsModule,
        CdkStepperModule,
        NgbTypeaheadModule,
        WarningsModule,
        MaterialPositionTableModule,
        InputModule,
        ClaimInformationDisplayModule,
        ClaimInformationFormModule,
        AttachmentsListDisplayModule
    ],
    declarations: [ClaimCreateNewComponent, StepClaimInformationComponent, StepPositionDetailComponent, StepConfirmSendComponent]
})
export class ClaimCreateNewModule {
}
